var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/verification/index.tsx";
import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { fetchVerificationConfig } from 'soapbox/actions/verification';
import { useAppDispatch, useAppSelector } from 'soapbox/hooks';
import Registration from './registration';
import AgeVerification from './steps/age-verification';
import EmailVerification from './steps/email-verification';
import SmsVerification from './steps/sms-verification';
export let ChallengeTypes;

(function (ChallengeTypes) {
  ChallengeTypes["EMAIL"] = "email";
  ChallengeTypes["SMS"] = "sms";
  ChallengeTypes["AGE"] = "age";
})(ChallengeTypes || (ChallengeTypes = {}));

const verificationSteps = {
  email: EmailVerification,
  sms: SmsVerification,
  age: AgeVerification
};

const Verification = () => {
  const dispatch = useAppDispatch();
  const isInstanceReady = useAppSelector(state => state.verification.instance.get('isReady') === true);
  const isRegistrationOpen = useAppSelector(state => state.verification.instance.get('registrations') === true);
  const currentChallenge = useAppSelector(state => state.verification.currentChallenge);
  const isVerificationComplete = useAppSelector(state => state.verification.isComplete);
  const StepToRender = verificationSteps[currentChallenge];
  React.useEffect(() => {
    dispatch(fetchVerificationConfig());
  }, []);

  if (isInstanceReady && !isRegistrationOpen) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 38,
        columnNumber: 12
      }
    });
  }

  if (isVerificationComplete) {
    return /*#__PURE__*/React.createElement(Registration, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 43,
        columnNumber: 7
      }
    });
  }

  if (!currentChallenge) {
    return null;
  }

  return /*#__PURE__*/React.createElement(StepToRender, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 5
    }
  });
};

export default Verification;